import { Experiment } from '@cian/experiments/ab';
import { Responsive, UIHeading2 } from '@cian/ui-kit';
import { Modal } from '@cian/ui-kit/modal';
import * as React from 'react';

import * as styles from './NewbuildingEntryPointExperiment.css';
import { NewbuildingServicesList } from './NewbuildingServicesList';
import { NEWBUILDING_ENTRYPOINT } from '../../constants/experiments';
import { INewbuildingServicesConfig } from '../../types/newbuildingService';
import { useApplicationContext } from '../ApplicationContext';

export interface INewbuildingEntryPointExperimentProps {
  children: React.ReactNode;
  trackClickQuickFilter: () => void;
}

export const NewbuildingEntryPointExperiment: React.FC<INewbuildingEntryPointExperimentProps> = ({
  children,
  trackClickQuickFilter,
}) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const { config } = useApplicationContext();

  const modalConfig = config.get<INewbuildingServicesConfig>('Newbuilding.EntryPoint.Config');

  const handleClick = React.useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    setIsModalOpen(true);
  }, []);

  return (
    <>
      <Experiment name={NEWBUILDING_ENTRYPOINT} group="A" default>
        <div
          className={styles['container']}
          onClick={trackClickQuickFilter}
          data-testid="NewbuildingEntryPointExperimentGroupA"
        >
          {children}
        </div>
      </Experiment>

      <Experiment name={NEWBUILDING_ENTRYPOINT} group="C">
        <div
          className={styles['container']}
          onClick={trackClickQuickFilter}
          data-testid="NewbuildingEntryPointExperimentGroupC"
        >
          {children}
        </div>
      </Experiment>

      <Experiment name={NEWBUILDING_ENTRYPOINT} group="B">
        <div className={styles['container']} data-testid="NewbuildingEntryPointExperimentGroupB" onClick={handleClick}>
          {children}
        </div>
        <Modal
          data-testid="NewbuildingEntryPointModal"
          open={isModalOpen}
          onOpenChange={setIsModalOpen}
          header={
            <>
              <Responsive phone>
                <UIHeading2>Новостройки</UIHeading2>
              </Responsive>
              <Responsive tablet desktop>
                <UIHeading2>Новостройки</UIHeading2>
              </Responsive>
            </>
          }
          footer={<div />}
        >
          <NewbuildingServicesList services={modalConfig?.services} />
        </Modal>
      </Experiment>
    </>
  );
};
